<template>
  <div class="content clearfix" style="padding: 15px; position: relative;">
    <table class="table table-striped scrollabletable">
      <thead>
      <tr>
        <th @click="sort('revisionable_id')">Account<span><img v-if="sortData.currentSort === 'revisionable_id'" :src="sorterArrow"></span></th>
        <th @click="sort('employee.name')">User<span><img v-if="sortData.currentSort === 'employee.name'" :src="sorterArrow"></span></th>
        <th @click="sort('key')">Field<span><img v-if="sortData.currentSort === 'key'" :src="sorterArrow"></span></th>
        <th @click="sort('old_value')">Old Value<span><img v-if="sortData.currentSort === 'old_value'" :src="sorterArrow"></span></th>
        <th @click="sort('new_value')">New Value<span><img v-if="sortData.currentSort === 'new_value'" :src="sorterArrow"></span></th>
        <th @click="sort('created_at')">Date<span><img v-if="sortData.currentSort === 'created_at'" :src="sorterArrow"></span></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="history in historyList" :key="history.id">
        <td>{{history.revisionable_id}}</td>
        <td v-if="history.employee">{{history.employee['name']}}</td>
        <td v-else></td>
        <td>{{history.key | getFieldLabel}}</td>
        <td>{{history.old_value}}</td>
        <td>{{history.new_value}}</td>
        <td>{{history.created_at | moment("MMM D, YYYY") }}</td>
      </tr>
      </tbody>
    </table>
    <div class="row am-backoffice-history-pagination" v-show="backOfficeHistoryList.length > pageSize">
      <div class="text-center">
        <pagination :allData="backOfficeHistoryList" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from './../http'
import pagination from '@/components/pagination/pagination.vue'
import sort from '@/mixins/tableSorter'
export default {
  data: function () {
    return {
      name: 'BackOfficeHistory',
      pageSize: 15,
      historyList: []
    }
  },
  components: {
    pagination
  },

  mixins: [sort],

  props: {
    accountId: {
      type: Number,
      default: 0
    }
  },
  asyncComputed: {
    backOfficeHistoryList: {
      get () {
        return api.makeRequest('/backoffice/history/' + this.accountId).then(
          (data) => {
            return data.data.results
          }
        )
      },
      default: []
    }
  },
  methods: {
    setPageData (data) {
      this.historyList = data
    }
  },
  filters: {
    getFieldLabel (field) {
      let fields = {
        owner_cell: 'Owner Cell',
        contact1: 'Contact 1',
        active: 'Active',
        conversion: 'Conversion',
        setup_fee: 'Setup Fee',
        ioPackageName: 'Version',
        ioCommission: 'Commission',
        ioOperatingName: 'Operating Name',
        ioDownload: 'Download',
        ioAllowBalance: 'Allow Balance',
        fax: 'Fax',
        cancel_date: 'Cancel Date',
        setup_billed: 'Setup Billed',
        owner_email: 'Owner Email',
        billing_email: 'Billing Email',
        bill_start_date: 'Billing Start Date',
        bill_notice: 'Bill Notice',
        acord_start_date: 'Acord Start Date',
        acord_renew: 'Acord Renew',
        bill_method: 'Bill Method',
        bill_plan: 'Bill Plan',
        setup_bill_start_date: 'Setup Start Date',
        backOfficeAddOns: 'Add Ons'
      }
      if (fields.hasOwnProperty(field)) {
        return fields[field]
      }
      return field.charAt(0).toUpperCase() + field.substr(1)
    }
  }
}
</script>

<style scoped>
  .table th {
    padding-bottom:5px;
    cursor: pointer;
  }
  .table thead {
    color: white;
    background-color: #444444;
  }
  .am-backoffice-history-pagination {
    padding: 15px 12px 0px 0px;
    margin: auto;
    text-align: center;
  }
  .scrollabletable thead,.scrollabletable tbody tr{
    display: table;
    width:100%;
    table-layout: fixed;
  }
  .scrollabletable tbody td{
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
  .scrollabletable tbody{
    display: block;
    max-height: 550px;
    overflow-y: auto;
  }
</style>
